// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.member-title {
  font-size: 1.5em;
  font-weight: bold;
}
.member-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1em;
  width: 100%;
}
.member-form-layout {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2em;
  width: 100%;
}
.member-form-action, .member-form-action:focus, .member-form-action:hover, .member-form-action:active {
  align-self: flex-end;
  outline: none;
  box-shadow: none !important;
  background-color: #fff;
  border: 1px solid #8f003c;
  color: #8f003c;
  padding-inline: 2em;
  margin-top: 2em;
}
.member-form-action:hover {
  background-color: #8f003c;
  color: #fff;
}

.member-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  width: 100%;
  margin-bottom: 2em;
}`, "",{"version":3,"sources":["webpack://./src/components/views/members/memberForm/memberForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,gBAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,gBAAA;EACA,iBAAA;AAAF;AAGC;ECPA,aAAA;EACA,sBAAA;EACA,uBDMqB;ECLrB,mBDK6B;EAC5B,WAAA;EACA,WAAA;AAEF;AAAE;EClBD,aAAA;EACA,uBDkBgB;ECjBhB,uBDiBwB;EACtB,eAAA;EACA,QAAA;EACA,WAAA;AAIH;AADE;EAIC,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBE7BK;EF8BL,yBAAA;EACA,cEnCQ;EFoCR,mBAAA;EACA,eAAA;AAAH;AAGE;EACC,yBEzCQ;EF0CR,WEtCK;AFqCR;;AAMA;EACC,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAHD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.member {\n\t@include flex(center, flex-start);\n\tmax-height: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-form {\n\t\t@include flexColumn(center, center);\n\t\tmargin: 1em;\n\t\twidth: 100%;\n\n\t\t&-layout {\n\t\t\t@include flex(center, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 2em;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&-action,\n\t\t&-action:focus,\n\t\t&-action:hover,\n\t\t&-action:active {\n\t\t\talign-self: flex-end;\n\t\t\toutline: none;\n\t\t\tbox-shadow: none !important;\n\t\t\tbackground-color: $white;\n\t\t\tborder: 1px solid $dark-red;\n\t\t\tcolor: $dark-red;\n\t\t\tpadding-inline: 2em;\n\t\t\tmargin-top: 2em;\n\t\t}\n\n\t\t&-action:hover {\n\t\t\tbackground-color: $dark-red;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n}\n\n.member-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgrid-template-rows: repeat(4, 1fr);\n\tgrid-column-gap: 1em;\n\tgrid-row-gap: 1em;\n\twidth: 100%;\n\tmargin-bottom: 2em;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
